/** Remove pontuação do documento (CPF/CNPJ). Mantém letras e números. */
export const unmaskDocument = value => String(value ?? '').replace(/[.\-/]/g, '');

/** CNPJ legado (somente dígitos, 14 caracteres) — consultável em APIs como CNPJá. */
export const isNumericCnpj = value => /^\d{14}$/.test(unmaskDocument(value));

const CNPJ_ALPHANUMERIC_DEFINITIONS = {
    '#': /[0-9A-Za-z]/,
};

const CNPJ_ALPHANUMERIC_MASK = {
    mask: '##.###.###/####-00',
    definitions: CNPJ_ALPHANUMERIC_DEFINITIONS,
    prepareChar: (str) => (/[a-z]/.test(str) ? str.toUpperCase() : str),
};

const CPF_MASK = { mask: '000.000.000-00', maxLength: 11 };

export const getDocumentMasks = (documentType = 'auto') => {
    if (documentType === 'cnpj') {
        return [CNPJ_ALPHANUMERIC_MASK];
    }

    if (documentType === 'cpf') {
        return [CPF_MASK];
    }

    return [CPF_MASK, CNPJ_ALPHANUMERIC_MASK];
};
